'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './events.routes';

import EventFiltersController from './event_filters.controller.js';
import FutureEventsController from './future_events.controller.js';
import ConcludedEventsController from './concluded_events.controller.js';

export default angular.module('everlaps.events', [uiRouter])
	.config(routing)
	.filter('TrimYear', function () {
		return function (input) {
			return input.toString().substring(2, 4);
		};
	})
	.filter('TrimMonth', function () {
		return function (input) {
			let aux = input.toString().substring(0, 3);
			return aux.charAt(0).toUpperCase() + aux.substr(1).toLowerCase() 
		};
	})
	.filter('propsFilter', function () {
		return function (items, props) {
			var out = [];

			if (angular.isArray(items)) {
				var keys = Object.keys(props);

				items.forEach(function (item) {
					var itemMatches = false;

					for (var i = 0; i < keys.length; i++) {
						var prop = keys[i];
						let p = item[prop];
						if (!p) continue;

						var text = props[prop].toLowerCase();
						if (p.toString().toLowerCase().indexOf(text) !== -1) {
							itemMatches = true;
							break;
						}
					}

					if (itemMatches) {
						out.push(item);
					}
				});
			} else {
				// Let the output be the input untouched
				out = items;
			}

			return out;
		};
	})
	.controller('EventFiltersController', EventFiltersController)
	.controller('FutureEventsController', FutureEventsController)
	.controller('ConcludedEventsController', ConcludedEventsController)
	.run(function($templateCache) {
		'ngInject';
		// http://blog.johnnyreilly.com/2016/05/inlining-angular-templates-with-webpack.html
		$templateCache.put("event_filters.html", require("./event_filters.html"));
	})
	.name;




// WEBPACK FOOTER //
// ./client/app/frontend/events/index.js